module.exports = __webpack_public_path__ + "img/837000031_4.e892ec4c.jpg";